'use client'

import { Row } from '@tanstack/react-table'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { RowActionBar, type RowAction } from '@/components/ui/row-action-bar'
import { useAdversaries } from '../context/adversary-context'
import { CaseAdversary } from '@/api/case'
import { useAuth } from '@/stores/authStore'
import { UserPermission } from '@/constants/permissions'

interface DataTableRowActionsProps {
  row: Row<CaseAdversary>
}

export function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const { t } = useTranslation()
  const { setOpen, setCurrentRow } = useAdversaries()
  const { can } = useAuth()

  const actions: RowAction[] = [
    {
      key: 'edit',
      icon: <Pencil className="h-4 w-4" />,
      label: t('edit'),
      hidden: !can(UserPermission.CHANGE_CASE_PARTY),
      onClick: () => {
        setCurrentRow(row.original)
        setOpen('edit')
      },
    },
    {
      key: 'delete',
      icon: <Trash2 className="h-4 w-4" />,
      label: t('delete'),
      destructive: true,
      hidden: !can(UserPermission.DELETE_CASE_PARTY),
      onClick: () => {
        setCurrentRow(row.original)
        setOpen('delete')
      },
    },
  ]

  return <RowActionBar actions={actions} />
}
